module.exports = __webpack_public_path__ + "img/HQ-Z7030-V1.1797a3a6.jpg";